import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=212539ae&scoped=true&"
var script = {}
import style0 from "./Support.vue?vue&type=style&index=0&id=212539ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212539ae",
  null
  
)

export default component.exports